import { z } from 'zod';

const JsonMetadataCompraAgilDetalleSchema = z.any();

const CompraAgilDetalleDataSchema = z.object({
  id: z.number(),
  nombre: z.string(),
  resumen: z.string().nullable(),
  codigo_externo: z.string(),
  codigo_estado: z.number(),
  estado_compra_agil: z.string(),
  estado_notificacion: z.string(),
  fecha_creacion: z.string().nullable(),
  fecha_cierre: z.string().nullable(),
  fecha_actualizacion: z.string().nullable(),
  fecha_resumen_procesado: z.string().nullable(),
  fecha_archivos_procesados: z.string().nullable(),
  filtro_resumen_aprobado: z.boolean().nullable(),
  filtro_archivos_aprobado: z.boolean().nullable(),
  archivos_descargados: z.boolean().nullable(),
  archivos_procesados: z.boolean().nullable(),
  resumen_procesado_filtro_palabras: z.boolean().nullable(),
  resumen_aprobado_filtro_palabras: z.boolean().nullable(),
  resumen_procesado_filtro_llm: z.boolean().nullable(),
  resumen_aprobado_filtro_llm: z.boolean().nullable(),
  resumen_llm: z.string().nullable(),
  resumen_general: z.string().nullable(),
  resumen_archivos_llm: z.string().nullable(),
  puntaje: z.number().nullable(),
  usuario_ultima_actualizacion_id: z.number().nullable(),
  json_metadata: JsonMetadataCompraAgilDetalleSchema.nullable(),
  fecha_adjudicacion: z.string().nullable(),
  fecha_postulacion: z.string().nullable(),
  adjudicado: z.boolean().nullable(),
  postulado: z.boolean().nullable()
});

const ArchivoCompraAgilDetalleSchema = z.object({
  nombre: z.string(),
  url_externa: z.string(),
  path_local: z.string()
});

const PreguntaRespuestaCompraAgilDetalleSchema = z.object({
  texto: z.string(),
  tipo: z.string(),
  orden: z.number()
});

export const CompraAgilDetalleResponseSchema = z.object({
  description: z.string(),
  status_code: z.number(),
  data: CompraAgilDetalleDataSchema,
  archivos: z.array(ArchivoCompraAgilDetalleSchema),
  preguntas_y_respuestas_compra_agil: z.array(PreguntaRespuestaCompraAgilDetalleSchema)
});

export type CompraAgilDetalleResponse = z.infer<typeof CompraAgilDetalleResponseSchema>;
export type CompraAgilDetalleData = z.infer<typeof CompraAgilDetalleDataSchema>;
export type JsonMetadataCompraAgilDetalle = z.infer<typeof JsonMetadataCompraAgilDetalleSchema>;
export type ArchivoCompraAgilDetalle = z.infer<typeof ArchivoCompraAgilDetalleSchema>;
export type PreguntaRespuestaCompraAgilDetalle = z.infer<typeof PreguntaRespuestaCompraAgilDetalleSchema>; 